/* global ol */

var DummyStopLocation = require('./dummyStopLocation');
var point = require('./util').point;
var style = require('./style');

function RouteLayer(route, color, highlightedRouteSequence) {
  this.route = route;
  this.color = color;
  this.highLightedRouteSequence = highlightedRouteSequence;

  this.layer = new ol.layer.Vector({
    source: new ol.source.Cluster({
      distance: 15,
      source: new ol.source.Vector({
        features: route.stopLocations
          .filter(this.hasCoordinates)
          .map(this.initFeature.bind(this))
      })
    }),
    style: this.style.bind(this),
    updateWhileAnimating: true,
    updateWhileInteracting: true,
    renderBuffer: 34
  });

  this.layer.set('route', this.route, true);
}

RouteLayer.prototype.initFeature = function(stop) {
  var feature = new ol.Feature();

  feature.setGeometry(point(stop));
  feature.set('stop', stop, true);
  feature.set('layer', this, true);
  feature.set('highlighted', this.highLightedRouteSequence === stop.routeSequence);

  return feature;
};

RouteLayer.prototype.hasCoordinates = function(stop) {
  return stop.latitude && stop.longitude;
};

RouteLayer.prototype.style = function(feature, resolution) {
  var features = feature.get('features');
  var stop = features.length === 1 && features[0].get('stop');
  var dummyStop = stop || new DummyStopLocation(features);
  var cancelled = ! dummyStop.notCancelled();
  var delivered = dummyStop.allDelivered();
  var deviation = delivered && dummyStop.anyDeviations();

  var options = {
    radius: this.radius(features.length),
    color: stop ? this.color : ol.color.asArray(this.color + 99),
    text: stop ? '' + stop.routeSequence : null
  };

  if (cancelled) {
    options.color = '#999';
  } else if (deviation) {
    options.deviation = true;
  } else if (delivered) {
    options.delivered = true;
  }

  if(this.shouldHighlight(features)){
    options.highlight = true;
  }
  return style(options, feature, resolution);
};

RouteLayer.prototype.shouldHighlight = function (features){
  return features.some(function(feature){
    return feature.get('highlighted');
  })
};

RouteLayer.prototype.radius = function(count) {
  switch (true) {
    case count > 29:
      return 17;
    case count > 19:
      return 15;
    case count > 9:
      return 13;
    default:
      return 11;
  }
};

RouteLayer.prototype.updateColor = function(color) {
  this.color = color;
  this.redraw();
};

RouteLayer.prototype.redraw = function() {
  this.layer.changed();
};

module.exports = RouteLayer;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/routeLayer.js
 ** module id = 187
 ** module chunks = 1
 **/